import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { PaymentScenarionConditionKindEnum } from '@zaoblako/shared/modules/task/enum/payment.scenarion.condition.kind.enum';
import { FinanceAccessService } from '@zaoblako/web/core/models/enums/access-rules/finance/finance-access.service';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';
import { PaymentTaskScenarioConditionKindNamePipe } from '@zaoblako/web/shared/pipes/payment-task-scenario-condition-kind-name.pipe';

@Component({
  selector: 'crm-payment-task-scenario-condition-kind-single-select',
  standalone: true,
  imports: [CommonModule, SingleSelectComponent, PaymentTaskScenarioConditionKindNamePipe],
  templateUrl: './payment-task-scenario-condition-kind-single-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentTaskScenarioConditionKindSingleSelectComponent {
  @Input() public kind: PaymentScenarionConditionKindEnum;
  @Input() public styleClass: string;
  @Input() public class: string;
  @Input() public appendTo: any;

  @Output() public kindChange: EventEmitter<PaymentScenarionConditionKindEnum> =
    new EventEmitter<PaymentScenarionConditionKindEnum>();

  public get options(): PaymentScenarionConditionKindEnum[] {
    return Object.values(PaymentScenarionConditionKindEnum).filter((option) => {
      if (option === PaymentScenarionConditionKindEnum.BUDGET_EXHAUSTED) {
        return false;
      }
      if (option === PaymentScenarionConditionKindEnum.DEAL && !this.financeAccessService.dealRights.canReadDeal) {
        return false;
      }
      return true;
    });
  }

  public constructor(private readonly financeAccessService: FinanceAccessService) {}
}
